import {Card} from 'platform/components';
import {Box, Grid, HStack, VStack} from 'platform/foundation';

import {range} from 'ramda';

import i18n from '@dms/i18n';
import {SkeletonLoadingBox} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useSkeletonRowCount} from '../../../hooks/useSkeletonRowCount';

// Lower bound in pixels for the compact cards after the vehicle summary.
const MIN_SECTION_HEIGHT_PX = 120;

export function ListingPreviewSkeleton(props: TestIdProps) {
  const sectionCount = useSkeletonRowCount(MIN_SECTION_HEIGHT_PX);
  return (
    <Box
      height="100%"
      maxHeight="100dvh"
      padding={4}
      backgroundColor="palettes.neutral.20.100"
      overflow="hidden"
      data-testid={suffixTestId('listing-preview-skeleton', props)}
    >
      <div role="status" aria-label={i18n.t('general.labels.loading')}>
        <VStack spacing={4}>
          <Card>
            <VStack spacing={4}>
              <HStack justify="space-between">
                <SkeletonLoadingBox isLoading width={28} height={6} />
                <SkeletonLoadingBox isLoading width={24} height={4} />
              </HStack>
              <SkeletonLoadingBox isLoading height={64} />
              <Grid columns={4} spacing={2}>
                {['first', 'second', 'third', 'more'].map((slot) => (
                  <SkeletonLoadingBox key={slot} isLoading height={16} />
                ))}
              </Grid>
              <SkeletonLoadingBox isLoading height={7} />
              <Box width="65%">
                <SkeletonLoadingBox isLoading height={5} />
              </Box>
              <Grid columns={3} spacing={2}>
                {['year', 'power', 'mileage'].map((slot) => (
                  <SkeletonLoadingBox key={slot} isLoading height={7} />
                ))}
              </Grid>
              <SkeletonLoadingBox isLoading height={24} />
            </VStack>
          </Card>
          {range(0, sectionCount).map((section) => (
            <Card key={section}>
              <VStack spacing={4}>
                <SkeletonLoadingBox isLoading width={20} height={4} />
                <SkeletonLoadingBox isLoading height={6} />
                <Box width="75%">
                  <SkeletonLoadingBox isLoading height={4} />
                </Box>
              </VStack>
            </Card>
          ))}
        </VStack>
      </div>
    </Box>
  );
}
